import Vue from 'vue'
import MfVueComponents from '@mf-node/mf-vue-components'

Vue.use(MfVueComponents)
